<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatter">
<p class="p"><span>‘Pauperism was a status, entry to which affected not merely a part of a man’s life, but the whole of it. He became a pauper for all purposes and he carried his family with him. Paupers formed a distinct group of second class citizens, deprived of the most important rights of citizenship; firstly the loss of personal reputation, secondly, the loss of personal freedom and, thirdly, the loss of political freedom by suffering disenfranchisement.’</span></p>
<p class="p-d"><span>T H Marshall, <em class="i">Social Policy</em>, 1965</span></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781783830763_fm01.vue?4843cacb